<template>
  <div>
    <modal></modal>
    <default-header/>
    <router-view class="router-view"/>
    <default-footer/>
  </div>
</template>
<script>
  import DefaultHeader from './DefaultHeader.vue'
  import DefaultFooter from './DefaultFooter.vue'
  import Modal from '@/components/Modal'

  export default {
    name: 'DefaultLayout',
    components: {
      DefaultHeader,
      DefaultFooter,
      Modal
    }
  }
</script>
<style>
  .router-view {
    margin-top: 75px;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/DefaultLayout.vue